import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

import { ENVIRONMENT } from "../../../../core/token";

const CouponErrors = {
	COUPON_DOES_NOT_EXISTS: { message: "Coupon does not exists", code: 1 },
	INVALID_COMPANY: { message: "Invalid company", code: 2 },
	PRODUCT_NOT_FOUND: { message: "Product not found", code: 3 },
	ERROR_ON_LICENSE_SERVICE: { message: "Error on license service", code: 4 },
	ALREADY_USED: { message: "ALREADY_USED", code: 5 },
};

@Component({
	templateUrl: "./coupon-response.component.html",
	styleUrls: ["./coupon-response.component.scss"],
	standalone: false,
})
export class CouponResponseComponent implements OnInit {
	icon: string;
	message_label: string;

	constructor(
		@Inject(ENVIRONMENT) protected environment,
		@Inject(MAT_DIALOG_DATA) public data: { error_response?: any },
		private matIconRegistry: MatIconRegistry,
		private domSanitizer: DomSanitizer,
	) {
		this.matIconRegistry.addSvgIcon("success", this.domSanitizer.bypassSecurityTrustResourceUrl(environment.cdnEndpoint + "assets/success.svg"));
		this.matIconRegistry.addSvgIcon("error", this.domSanitizer.bypassSecurityTrustResourceUrl(environment.cdnEndpoint + "assets/error.svg"));
		this.icon = data.error_response ? "error" : "success";
		if (data.error_response === undefined) {
			this.message_label = "admin-coupons-view.redeemed-success";
		} else {
			this.message_label = "admin-coupons-view.errors.";
			if (data.error_response.code === undefined) {
				this.message_label += "unknown-error";
			} else {
				switch (data.error_response.code) {
					case CouponErrors.COUPON_DOES_NOT_EXISTS.code:
						this.message_label += "not-exist";
						break;
					case CouponErrors.ALREADY_USED.code:
						this.message_label += "already-used";
						break;
					case CouponErrors.ERROR_ON_LICENSE_SERVICE.code:
						this.message_label += "license-service";
						break;
					case CouponErrors.INVALID_COMPANY.code:
						this.message_label += "invalid-company";
						break;
					case CouponErrors.PRODUCT_NOT_FOUND.code:
						this.message_label += "product-not-found";
						break;
					default:
						this.message_label += "unknown-error";
						break;
				}
			}
		}
	}

	ngOnInit() {}
}
